export default __webpack_public_path__ + "static/media/404_dox.4e7ad2c9.png";